// TableSkeleton.js
import React from "react";

export default function TableSkeleton({ type = "items", rows = 10 }) {
  const columns =
    type === "items"
      ? ["Item", "Category", "Quantity", "Reorder Level", "Expiry", "Created"]
      : ["Item", "Type", "Quantity", "Reason", "Created", "Created by"];

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="bg-gray-50 text-left select-none">
            {columns.map((col, idx) => (
              <th
                key={idx}
                className="px-4 py-2 border-b font-medium text-gray-600"
              >
                <div className="h-4 w-24 bg-gray-300 rounded-md animate-pulse" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx} className="bg-white">
              {columns.map((_, colIdx) => (
                <td key={colIdx} className="px-4 py-2 border-b">
                  <div className="h-3 bg-gray-200 rounded-md animate-pulse w-full" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
